export default __webpack_public_path__ + "static/media/classroomImg4.99f147a8.svg";